export const getActiveMenuTab = (state) => state.global.activeSideMenuTab;